module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group"
  }, [_c('h2', [_vm._v(_vm._s(_vm.label) + " "), (_vm.required) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('p', {
    class: {
      error: _vm.error
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('ClientColorButton', {
    staticClass: "buttonSelect",
    attrs: {
      "size": 'xs',
      "width": 'auto'
    },
    on: {
      "click": function($event) {
        _vm.updateGlobalValue();
      }
    }
  }, [(_vm.allOptionAreSelected) ? [_vm._v("\n            " + _vm._s(_vm.$t("common.selectNone")) + "\n        ")] : [_vm._v("\n            " + _vm._s(_vm.$t("common.selectAll")) + "\n        ")]], 2), _vm._v(" "), _c('section', [_vm._l((_vm.readonlyOptions), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "checkbox checked readonly"
    }, [_c('label', {
      staticClass: "cutWordM"
    }, [(_vm.haveLogo) ? _c('span', {
      staticClass: "picture-icon"
    }, [_c('img', {
      attrs: {
        "src": option.logo || '../../../assets/catalog.png'
      }
    })]) : _vm._e(), _vm._v(" " + _vm._s(option.label) + "\n            ")])])
  }), _vm._v(" "), _vm._l((_vm.optionsUsable), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "checkbox",
      class: {
        checked: _vm.value.includes(option.value)
      }
    }, [_c('label', {
      class: {
        forDisabled: option.disabled, cutWordM: true
      },
      attrs: {
        "for": (_vm.name + "-" + (option.value))
      }
    }, [_c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.haveLogo),
        expression: "!haveLogo"
      }],
      ref: (_vm.name + "-" + (option.value)),
      refInFor: true,
      attrs: {
        "type": "checkbox",
        "id": (_vm.name + "-" + (option.value)),
        "disabled": option.disabled
      },
      domProps: {
        "checked": _vm.value.includes(option.value)
      },
      on: {
        "input": function (e) { return _vm.selectValue(option.value, e); }
      }
    }), _vm._v(" "), (_vm.haveLogo) ? _c('span', {
      staticClass: "picture-icon"
    }, [_c('img', {
      attrs: {
        "src": option.logo || '../../../assets/catalog.png'
      }
    })]) : _vm._e(), _vm._v(" " + _vm._s(option.label) + "\n            ")])])
  })], 2), _vm._v(" "), _c('ClientColorButton', {
    staticClass: "buttonSelect",
    attrs: {
      "size": 'xs'
    },
    on: {
      "click": function($event) {
        _vm.updateGlobalValue();
      }
    }
  }, [(_vm.allOptionAreSelected) ? [_vm._v("\n            " + _vm._s(_vm.$t("common.selectNone")) + "\n        ")] : [_vm._v("\n            " + _vm._s(_vm.$t("common.selectAll")) + "\n        ")]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75beac50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Form/CheckboxGroupBloc.vue
// module id = 3272
// module chunks = 0